import { CSSProperties, FC } from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';
import Typography from '@material-ui/core/Typography';
import DiamondIcon from 'mdi-react/DiamondIcon';
import { Header } from '../Header';
import { Button } from '../Button';
import { Color } from '../Theme';

export const PremiumBannerStyle = styled.div`
  display: flex;
  padding: 3rem;
  background: linear-gradient(172deg, ${transparentize(0.85, Color.primary)} 0%, ${transparentize(0.6, Color.primary)} 100%);

  h2 {
    color: ${Color.primary};

    svg {
      opacity: 0.6;
    }
  }

  p {
    margin-top: 1.3rem;
    margin-bottom: 0;
    opacity: 0.75;
  }

  > div:first-of-type {
    max-width: 70%;
  }

  > div:last-of-type {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const OmnibarPremiumBanner: FC<{ title?: string | JSX.Element; description?: string | JSX.Element; style?: CSSProperties }> = ({
  title,
  description,
  style = {},
}) => (
  <PremiumBannerStyle style={style}>
    <div>
      <Header icon={<DiamondIcon color={Color.primary} />}>{title ?? 'Hakukriteerit vaativat Constle Pro -jäsenyyden'}</Header>
      <Typography variant="body1" component="p">
        {description ||
          'Hakukriteerien käyttö on osa Constle Pro -jäsenyyttä. Jäsenenä pääset nauttimaan kaikista Constlen tuomista eduista. Liity jäseneksi jo tänään!'}
      </Typography>
    </div>
    <div>
      <Button href="/premium">Lue lisää</Button>
    </div>
  </PremiumBannerStyle>
);
